module.exports = __webpack_public_path__ + "static/media/20210410_173300_733_IMG_0237.28f5436b.jpg";